import * as API from "./base";

export const create = (id, props) =>
  API.post("/recommendation_request/" + id + "/submission", props);
